<script>
    import ButtonWrapperPrimary from '../../buttons/button-wrapper-primary.svelte';
    import { BONUS_GAMES } from '@src/constants';

    export let allowToStart = false;
    export let typeBonusGame;

    $: bonusTypeText =
        typeBonusGame === BONUS_GAMES.BALL_SPIN || typeBonusGame === BONUS_GAMES.CASH_REELS ? 'Spin' : 'Play';
</script>

<div class="flex place-items-center justify-center gap-x-3 desktop:h-32 desktop:gap-x-4">
    <ButtonWrapperPrimary
        class="group h-20 w-20  hover:cursor-pointer desktop:h-24 desktop:w-24"
        disabled={!allowToStart}
        on:click
    >
        <div
            class="primary-button-content text-shadow-main-control cstm-position-center font-Roboto
text-2xl font-bold uppercase text-white desktop:text-[30px]"
        >
            {bonusTypeText}
        </div>
    </ButtonWrapperPrimary>
</div>
